import React from 'react';
import { Input, Button, Select, SelectSearch } from 'components';
import { ComboService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { CloseIcon } from 'assets/icons';
import { InventoryService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
}

class ModalAdd extends React.Component<Props> {

	state = {
		form: {
			quantity: 0,
			movement_type_id: '',
			product_id: ''
		},
		products: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await InventoryService.admin.getProducts();
		this.setState({
			products: res.products
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async () => {
		if (!this.state.form.product_id) {
			Globals.showError("Debe indicar el producto");
			return;
		}
		if (!this.state.form.movement_type_id) {
			Globals.showError("Debe indicar el tipo de movimiento");
			return;
		}
		if (this.state.form.quantity <= 0) {
			Globals.showError("La cantidad debe ser mayor a 0");
			return;
		}

		const product: any = this.state.products.find((i: any) => i.id == this.state.form.product_id);
		if (this.state.form.movement_type_id == Constants.MOVEMENT_TYPES.REMOVE.toString() && (product?.stock - this.state.form.quantity < 0)) {
			Globals.showError("El producto posee existencia de " + product?.stock);
			return;
		}

		await InventoryService.admin.save({
			...this.state.form,
			user_id: this.props.user?.id
		});
		Globals.showSuccess("Se ha modificado la existencia del producto");
		this.props.onClose();
	}
	
	render() {
		const product: any = this.state.products.find((i: any) => i.id == this.state.form.product_id);

		return (
			<div id="modal-add-inventory">
				<div className="container-close">
					<h3>Movimiento de productos</h3>
					<button className="btn-close" onClick={ () => this.props.onClose() }>
						<img src={ CloseIcon } />
					</button>
				</div>
				<SelectSearch
					label="Producto"
					onChange={ (product: any) => {
						this.setState({
							form: {
								...this.state.form,
								product_id: product?.value
							}
						});
					} }
					color="white"
					searchRight
					value={ product ? {
						value: product.id,
						label: product.name
					} : null }
					options={ this.state.products.map((i: any) => {
						return {
							value: i.id,
							label: i.name + (i?.type_id == Constants.PRODUCT_TYPES.PRODUCT ? (' - ' + (i?.presentation?.name || '')) : '')
						}
					}) } />

				{ product != null && <p className="stock">Existencia: { product?.stock }</p> }

				<Select
					label="Tipo de movimiento"
					name="movement_type_id"
					onChange={ this.change }
					value={ this.state.form.movement_type_id }
					options={ [
						{ value: Constants.MOVEMENT_TYPES.ADD.toString(), label: 'Ingreso' },
						{ value: Constants.MOVEMENT_TYPES.REMOVE.toString(), label: 'Egreso' },
					] } />
				<Input
					type="number"
					color="white"
					value={ this.state.form.quantity }
					name="quantity" 
					label="Cantidad"
					onChange={ this.change } />
				<div className="text-center">
					<button className="btn-save" onClick={ () => this.submit() }>
						Guardar
					</button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalAdd);